import { useEffect, useState } from 'react';

const FFT_SIZE = 64;
const SMOOTHING_TIME_CONSTANT = 0.8;

export const useAudioAnalyser = (mediaStream: MediaStream | null): AnalyserNode | null => {
   const [analyser, setAnalyser] = useState<AnalyserNode | null>(null);

   useEffect(() => {
      if (mediaStream === null) {
         setAnalyser(null);
         return undefined;
      }

      const audioContext = new AudioContext();
      const source = audioContext.createMediaStreamSource(mediaStream);
      const nextAnalyser = audioContext.createAnalyser();
      nextAnalyser.fftSize = FFT_SIZE;
      nextAnalyser.smoothingTimeConstant = SMOOTHING_TIME_CONSTANT;
      source.connect(nextAnalyser);

      if (audioContext.state === 'suspended') {
         audioContext.resume().catch(() => undefined);
      }

      setAnalyser(nextAnalyser);

      return () => {
         source.disconnect();
         nextAnalyser.disconnect();
         audioContext.close().catch(() => undefined);
         setAnalyser(null);
      };
   }, [mediaStream]);

   return analyser;
};
